import { useEffect, useId, useRef, type ReactNode } from 'react';

type Props = {
  titulo: string;
  descricao?: ReactNode;
  children?: ReactNode;
  rotuloConfirmar: string;
  /** Ação que tira algo do quadro (Lixeira): botão em vermelho. */
  perigo?: boolean;
  podeConfirmar?: boolean;
  aoConfirmar: () => void;
  aoCancelar: () => void;
};

/**
 * Caixa de diálogo modal acessível (WCAG 2.1 AA): `<dialog>` nativo aberto com showModal(), que prende o foco
 * dentro da caixa, devolve o foco ao fechar e cancela com Esc. Título e descrição rotulam a caixa.
 */
export function Dialogo({ titulo, descricao, children, rotuloConfirmar, perigo, podeConfirmar = true, aoConfirmar, aoCancelar }: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  const id = useId();

  useEffect(() => {
    const dialogo = ref.current;
    if (dialogo && !dialogo.open) dialogo.showModal();
    return () => dialogo?.close();
  }, []);

  return (
    <dialog
      ref={ref}
      className="dialogo"
      aria-labelledby={`${id}-titulo`}
      aria-describedby={descricao ? `${id}-descricao` : undefined}
      onCancel={(evento) => {
        evento.preventDefault();
        aoCancelar();
      }}
    >
      <form
        onSubmit={(evento) => {
          evento.preventDefault();
          if (podeConfirmar) aoConfirmar();
        }}
      >
        <h2 id={`${id}-titulo`} className="dialogo__titulo">
          {titulo}
        </h2>
        {descricao && (
          <div id={`${id}-descricao`} className="dialogo__descricao">
            {descricao}
          </div>
        )}
        {children}
        <footer className="dialogo__acoes">
          <button type="button" className="botao botao--secundario" onClick={aoCancelar}>
            Cancelar
          </button>
          <button type="submit" className={`botao ${perigo ? 'botao--perigo' : 'botao--primario'}`} disabled={!podeConfirmar}>
            {rotuloConfirmar}
          </button>
        </footer>
      </form>
    </dialog>
  );
}
